import { useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router';
import PropTypes from 'prop-types';
import Grid from './MetaGrid';
import withMeta from '../utils/withMeta';

const FORBIDDEN = "/stranka_nenajdena";

const Form = (props) => {
  const { componentFactory, filterFactory, reducer, akcFactory, currentElFactory, getComponent, selectAkcFactory } = props;
  const { id, db } = useParams();
  const location = useLocation()
  const navigate = useNavigate()
  let nIdentif = props.meta.menu.find(x => x.Route === location.pathname)?.NIdentif;

  // HACK: konencie do inej DB z NIdentif
  if (nIdentif && nIdentif.includes("@")) {
    nIdentif = nIdentif.split("@").pop()
  }

  useEffect(() => {
    const forbidden = props.meta.menu.length > 0 && !props.meta.menu.some(x => x.Route === location.pathname && x.Visible === 1)

    if (forbidden) {
      navigate(FORBIDDEN)
    }
  }, [props.meta.menu, location, navigate])

  return (
    <div className="row m-0">
      <div className="col p-0">
        <Grid
          primaryField={nIdentif || props.primaryField || id}
          componentFactory={componentFactory}
          reducer={reducer}
          filterFactory={filterFactory}
          akcFactory={akcFactory}
          currentElFactory={currentElFactory}
          fixedFilter={props.fixedFilter}
          disabled={props.disabled}
          hidden={props.hidden}
          getComponent={getComponent}
          selectAkcFactory={selectAkcFactory}
          db={db}
        />
      </div>
    </div>
  );

}

Form.propTypes = {
  primaryField: PropTypes.string,
  componentFactory: PropTypes.func,
  reducer: PropTypes.func,
  filterFactory: PropTypes.func,
  akcFactory: PropTypes.func,
  fixedFilter: PropTypes.object,
  disabled: PropTypes.number,
  hidden: PropTypes.number,
  currentElFactory: PropTypes.func,
}

export default withMeta(Form);
